import React, { useEffect } from "react";
import "./FeedbackListStyle.css";
import PrimaryButton from "../../../components/globalComponents/buttons/primaryButton/PrimaryButton";
import {
  feedbackData,
  getStudentFeedbacks,
} from "../../../reducers/feedbackSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../components/globalComponents/PageLoader/PageLoader";
import moment from "moment";

const FeedbackList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [searchFeedback, setSearchFeedback] = useState("");
  // const [feedbackType, setFeedbackType] = useState("");
  // const [statusType, setStatusType] = useState("");
  const searchFeedback=""
  const feedbackType=""
  const statusType=""

  //pagination
  // const [pageNo, setPageNo] = useState("1");
  // const [pageSize, setPageSize] = useState("10");
  const pageNo=""
  const pageSize=""

  const { isFetching, feedbackList } =
    useSelector(feedbackData);

  // const onSubmitClick = (feedbackId) => {
  //     navigate(`/submitFeedback/${feedbackId}`)
  // }
  // const onViewResponse = (feedbackId) => {
  //     navigate(`/feedbackAnswers/${feedbackId}`)
  // }

  // const setPreviousPage = () => {
  //     if (pageNo === '1') {
  //         return;
  //     }
  //     setPageNo((prev) => --prev);
  // }
  // const setNextPage = () => {
  //     if (pageNo == Math.ceil(feedbackListCount / pageSize)) {
  //         return;
  //     }
  //     setPageNo((prev) => ++prev);
  // }
  // const onSearchKeyPress = (e) => {
  //     if (e.key === 'Enter') {
  //         e.preventDefault();
  //         searchByTitle(e.target.value);
  //     }
  // }

  // const onClickSearch = () => {
  //     searchByTitle(searchFeedback);
  // }

  // const handleSearch = (event) => {
  //     var search = event.target.value;
  //     setSearchFeedback(search);
  // };

  // const searchByTitle = (val) => {
  //     try {
  //         var params = {
  //             searchTitle: val,
  //             searchParams: feedbackType,
  //             status: statusType,
  //         };
  //         dispatch(getStudentFeedbacks(params));
  //     } catch (error) {
  //         console.log("error", error);
  //     }
  // };

  useEffect(() => {
    var params = {
      searchTitle: searchFeedback,
      searchParams: feedbackType,
      status: statusType,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    dispatch(getStudentFeedbacks(params));
    // eslint-disable-next-line
  }, [feedbackType, statusType, pageNo, pageSize]);

  // const handleFeedbackType = (event) => {
  //     var type = event.target.value;
  //     if (type === undefined || type === null) {
  //         return;
  //     }
  //     setFeedbackType(type);
  // };

  // const handleStatusChange = (event) => {
  //     var statusType = event.target.value;
  //     if (statusType === undefined || statusType === null) {
  //         return;
  //     }
  //     setStatusType(statusType);
  // };

  // const handlePageSizeChange = (event) => {
  //     setPageSize(event.target.value)
  // }

  return (
    <>
      {isFetching && <PageLoader />}
      <div className="feedbackContainer">
        <div className="pageHeader">
          <p className="componentHeading"></p>
          <div className="pageTogglers">
            <div className="pageToggler active">
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.97329 1.875H14.0268C14.7042 1.87499 15.2505 1.87499 15.6929 1.91114C16.1485 1.94835 16.5486 2.02699 16.9188 2.2156C17.5068 2.51521 17.9848 2.99327 18.2844 3.58128C18.4731 3.95146 18.5517 4.35158 18.5889 4.80711C18.6251 5.24953 18.625 5.79587 18.625 6.47323V11.0268C18.625 11.7041 18.6251 12.2505 18.5889 12.6929C18.5517 13.1484 18.4731 13.5485 18.2844 13.9187C17.9848 14.5067 17.5068 14.9848 16.9188 15.2844C16.5486 15.473 16.1485 15.5516 15.6929 15.5889C15.2505 15.625 14.7042 15.625 14.0268 15.625H11.9032C11.3581 15.625 11.1722 15.6279 11 15.6633C10.8345 15.6972 10.6744 15.7534 10.524 15.8303C10.3674 15.9102 10.2205 16.0241 9.79482 16.3646L7.78766 17.9703C7.63105 18.0956 7.48187 18.215 7.35287 18.3003C7.22825 18.3827 7.01752 18.5078 6.75117 18.5081C6.43394 18.5084 6.13384 18.3642 5.93593 18.1163C5.76977 17.9081 5.73583 17.6654 5.72232 17.5166C5.70833 17.3626 5.70835 17.1715 5.70837 16.971L5.70837 15.6228C5.29811 15.6168 4.9776 15.5953 4.69123 15.5185C3.61282 15.2296 2.77048 14.3872 2.48152 13.3088C2.37464 12.9099 2.3748 12.4448 2.37502 11.7632C2.37503 11.7315 2.37504 11.6993 2.37504 11.6667L2.37504 6.47325C2.37503 5.79588 2.37503 5.24953 2.41118 4.80711C2.4484 4.35158 2.52703 3.95146 2.71565 3.58128C3.01525 2.99327 3.49331 2.51521 4.08132 2.2156C4.4515 2.02699 4.85162 1.94835 5.30715 1.91114C5.74958 1.87499 6.29592 1.87499 6.97329 1.875ZM5.40894 3.15699C5.03071 3.18789 4.81341 3.2455 4.64881 3.32936C4.29601 3.50913 4.00917 3.79596 3.8294 4.14877C3.74554 4.31337 3.68793 4.53067 3.65703 4.9089C3.62553 5.29443 3.62504 5.78962 3.62504 6.5V11.6667C3.62504 12.4819 3.63041 12.7669 3.68893 12.9853C3.86231 13.6323 4.36771 14.1377 5.01476 14.3111C5.23316 14.3696 5.51816 14.375 6.33337 14.375C6.67855 14.375 6.95837 14.6548 6.95837 15V16.9462C6.95837 16.9768 6.95839 17.0056 6.95842 17.0328C6.9797 17.0159 7.00221 16.9979 7.02607 16.9788L9.01395 15.3885C9.02984 15.3758 9.04552 15.3632 9.06099 15.3508C9.42186 15.062 9.67175 14.862 9.95527 14.7171C10.206 14.589 10.4729 14.4954 10.7487 14.4388C11.0606 14.3748 11.3807 14.3749 11.8429 14.375C11.8627 14.375 11.8828 14.375 11.9032 14.375H14C14.7104 14.375 15.2056 14.3745 15.5911 14.343C15.9694 14.3121 16.1867 14.2545 16.3513 14.1706C16.7041 13.9909 16.9909 13.704 17.1707 13.3512C17.2545 13.1866 17.3122 12.9693 17.3431 12.5911C17.3746 12.2056 17.375 11.7104 17.375 11V6.5C17.375 5.78962 17.3746 5.29443 17.3431 4.9089C17.3122 4.53067 17.2545 4.31337 17.1707 4.14877C16.9909 3.79596 16.7041 3.50913 16.3513 3.32936C16.1867 3.2455 15.9694 3.18789 15.5911 3.15699C15.2056 3.12549 14.7104 3.125 14 3.125H7.00004C6.28966 3.125 5.79447 3.12549 5.40894 3.15699ZM10.8119 6.05964C10.5213 6.00979 10.2224 6.06441 9.96816 6.21381C9.71395 6.36322 9.52081 6.59777 9.42296 6.87593C9.30841 7.20155 8.95159 7.37266 8.62597 7.25811C8.30035 7.14357 8.12925 6.78675 8.24379 6.46113C8.4396 5.9045 8.82609 5.43512 9.33481 5.13615C9.84353 4.83717 10.4416 4.72788 11.0232 4.82764C11.6048 4.92739 12.1323 5.22975 12.5123 5.68117C12.8922 6.13245 13.1002 6.70357 13.0994 7.29345C13.0992 8.24956 12.3904 8.88091 11.8843 9.2183C11.6122 9.39969 11.3446 9.53307 11.1474 9.6207C11.0479 9.66491 10.9642 9.69845 10.9038 9.72145C10.8736 9.73296 10.8491 9.74189 10.8312 9.74823L10.8095 9.75583L10.8026 9.75819L10.8002 9.75901L10.7992 9.75933C10.799 9.75939 10.7984 9.75959 10.6008 9.16667L10.7992 9.75933C10.4718 9.86849 10.117 9.69177 10.0079 9.36431C9.89887 9.03728 10.0752 8.68384 10.4019 8.57418C10.4022 8.57407 10.4025 8.57396 10.4028 8.57385L10.4125 8.57046C10.4221 8.56705 10.4378 8.56134 10.4588 8.55334C10.5009 8.5373 10.5635 8.51229 10.6397 8.47843C10.7939 8.40993 10.9946 8.30911 11.1909 8.17823C11.6216 7.89113 11.8494 7.58581 11.8494 7.29306L11.8494 7.29213C11.8498 6.99726 11.7459 6.71175 11.556 6.48617C11.3661 6.26059 11.1025 6.10949 10.8119 6.05964ZM9.99996 11.6667C9.99996 11.3215 10.2798 11.0417 10.625 11.0417H10.6333C10.9785 11.0417 11.2583 11.3215 11.2583 11.6667C11.2583 12.0118 10.9785 12.2917 10.6333 12.2917H10.625C10.2798 12.2917 9.99996 12.0118 9.99996 11.6667Z"
                  fill="#262626"
                />
              </svg>
              List of feedback
            </div>
          </div>
          <div></div>
        </div>
        {/* <div className="filterBar">
          <div className="searchBox">
            <img src="../assets/icons/search-sm.svg" alt="" />
            <input
              type="text"
              className="searchInput"
              placeholder="Search ..."
            />
          </div>
          <button className="fiterBtn">
            {" "}
            <img src="../assets/icons/filter-lines.svg" alt="" /> Filters
          </button>
        </div> */}
        <div className="feedbackTableContainer">
          <table className="feedbackTable" cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>Feedback</th>
                <th>Program</th>
                <th>Cohort</th>
                <th>Published On</th>
                <th>Feedback Type</th>
                {/* <th>Created By</th> */}
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            {feedbackList.length > 0 && (
              <tbody>
                {feedbackList.map((feed) => (
                  feed.Feedback.feedbackType !== 'Quiz' &&
                  <tr>
                    <td>{feed?.Feedback.title}</td>
                    <td>{feed.Student.Program.programName}</td>
                    <td>{feed.Student.ProgramDetail.name}</td>
                    <td>
                      {moment(feed?.Feedback.publishedOn).format("DD/MM/YYYY")}
                    </td>
                    <td>{feed?.Feedback.feedbackType}</td>
                    {/* <td>
                      {feed?.Feedback.Admin.firstName}{" "}
                      {feed?.Feedback.Admin.lastName}
                    </td> */}
                    <td>
                      {feed.isAttempted && (
                        <div className="successTag">Completed</div>
                      )}
                      {feed.Feedback.status === "expire" && !feed.isAttempted &&
                         (
                          <div className="tag-expired">Expired</div>
                        )}
                      {
                        feed.Feedback.status === "active" &&
                        !feed.isAttempted && (
                          <div className="primaryTag">Pending</div>
                        )}
                    </td>
                    {feed.Feedback.status !== "expire" && (
                      <td>
                        {feed.isAttempted ? (
                          <PrimaryButton
                            classname={"successSecondaryBtnSmall"}
                            onClick={() =>
                              navigate(`/FeedBackPreview/${feed?.Feedback.id}`)
                            }
                            children={"View"}
                          />
                        ) : (
                          <PrimaryButton
                            onClick={() =>
                              navigate(`/submitFeedback/${feed?.Feedback.id}`)
                            }
                            classname={"dangerOutlineBtnSmall"}
                            children={"Attempt"}
                          />
                        )}
                      </td>
                    )}
                    {feed?.Feedback?.status === "expire" &&
                      !feed?.isAttempted && <td>-</td>}
                    {feed?.Feedback?.status === "expire" && feed?.isAttempted && (
                      <td>
                        {" "}
                        <PrimaryButton
                          classname={"successSecondaryBtnSmall"}
                          onClick={() =>
                            navigate(`/FeedBackPreview/${feed?.Feedback.id}`)
                          }
                          children={"View"}
                        />
                      </td>
                    )}
                  </tr>
                ))}
                {/* <tr>
                            <td>Product Management | Session- 1</td>
                            <td>Applied Finance</td>
                            <td>Cohort - 1</td>
                            <td>1/20/22</td>
                            <td>Class Feedback</td>
                            <td>Isham Taneja</td>
                            <td><div className="successTag">Submitted</div></td>
                            <td>
                                <PrimaryButton classname={'successSecondaryBtnSmall'} children={'View'} />
                            </td>
                        </tr> */}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

export default FeedbackList;
